
        var result = require("!!./../../../../../../node_modules/css-loader/index.js!./../../../../../../node_modules/sass-loader/lib/loader.js!./page-ribbon.scss");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./src/main/webapp/app/layouts/profiles/page-ribbon.scss
// module id = 466
// module chunks = 0